// Copilot control-mode telemetry — the privacy boundary (WP-H3).
//
// Deliberately dependency-free (no TypeScript import, no app config) so this
// same file can be exercised by a plain Node self-check
// (scripts/self-check-control-telemetry.mjs) with no build step, in addition
// to being bundled into the app via `controlTelemetry.js`. `.mjs` so Node's
// loader always treats it as an ES module regardless of package.json "type".
//
// ANY field not named here is dropped before a Copilot control-mode event
// ever reaches `posthog.capture`. This is what keeps typed values, input
// labels, narration text, and DOM snapshots — none of which belong in
// analytics — out of the payload, even if a caller passes them in by
// accident. Keep this list in lockstep with `CopilotControlEventProps` in
// `campaign-builder/analytics/cbAnalytics.ts`; widening one without the
// other is the mistake this file exists to prevent.
export const ALLOWED_PROPS = [
  "conversation_id",
  "campaign_id",
  "host",
  "grant_scope",
  "action",
  "cy",
  "status",
  "step",
  "actions_used",
  "duration_ms",
  "reason",
  "path",
];

/**
 * Strip a candidate props object down to exactly the allowlisted fields.
 * @param {Record<string, unknown>} props
 * @returns {Record<string, unknown>}
 */
export const sanitizeControlEvent = (props) => {
  const safe = {};
  for (const key of ALLOWED_PROPS) {
    if (props && props[key] !== undefined) safe[key] = props[key];
  }
  return safe;
};
